<ng-container *ngIf="tuning">
  <div *ngFor="let tuningText of getTuningTextArray(tuning.notes, tuning.preferredNote12)">
    <div *ngFor="let md of tuningText.mds; let mdi = index">
      <img 
        *ngIf="tuningText.photos && tuningText.photos[mdi] && tuningText.photos[mdi].name" 
        [ngStyle]="{
          'max-width': tuningText.photos[mdi].width + 'px',
          'float': ((mdi % 2) === 0) ? 'right' : 'left',
          'margin': ((mdi % 2) === 0) ? '0 0 12px 12px' : '0 12px 12px 0'
        }" 
        src="/assets/imgs/{{tuningText.photos[mdi].name}}" />
      <div [innerHTML]="md |markdown"></div><br />
    </div> 
  </div>
</ng-container>
